import { render, staticRenderFns } from "./newExamTopicDialog.vue?vue&type=template&id=00aea8c4"
import script from "./newExamTopicDialog.vue?vue&type=script&lang=js"
export * from "./newExamTopicDialog.vue?vue&type=script&lang=js"
import style0 from "./newExamTopicDialog.vue?vue&type=style&index=0&id=00aea8c4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports